//import api_patho_opd_job_worklist from "@/api/api_patho_opd_job_worklist";
import {  getBaseURLforBackEnd , getConfigAxios ,myTimeZone }  from '@/utils.js'
import axios from "axios";
import master_data from "./master_data";
import moment from 'moment-timezone' 



export default {
    namespaced: true,

    state: {
        opdPathoJobList: [],
        firstInteract : true,

        dataGroupAndDetailAutomate:[],
        dataGroupAndDetailNonAutomate:[],
        dvmArr : [],
        deptArr: [],

        opdResultSearch : [],

         

        HNSelected : null,
        MemberSelected : null,
        automateOrNoneAutomateMode : null, // automateOrNoneAutomateMode == 0 ? 'Automate' : 'Non Automate'
        ItemsSelected : [],

        // for Automate
        checkedRowsDetailAutomate:[],
        dvmSelectedAutomate : null,
        deptSelectedAutomate : null,
        dvmAutocompleteAutomate : '',
        deptAutocompleteAutomate: '', 


        // for NonAutomate
        checkedRowsDetailNonAutomate:[],
        dvmSelectedNonAutomate : null,
        deptSelectedNonAutomate : null,
        dvmAutocompleteNonAutomate : '',
        deptAutocompleteNonAutomate: '', 



        // date Parameter
        datePathoJobStart : null,
        datePathoJobStop : null,

    },

    getters: {
        // availableProducts (state, getters) {
        //     return state.items.filter(product => product.inventory > 0)
        // },
        //
        // productIsInStock () {
        //     return (product) => {
        //         return product.inventory > 0
        //     }
        // }
    },

    mutations: {
         

        setDatePathoJobStart  (state, datePathoJobStart) {
            state.datePathoJobStart = datePathoJobStart
        },

        setDatePathoJobStop  (state, datePathoJobStop) {
            state.datePathoJobStop = datePathoJobStop
        },




        // for NonAutomate
        setDVMAutocompleteNonAutomate  (state, dvmAutocompleteNonAutomate) {
            state.dvmAutocompleteNonAutomate = dvmAutocompleteNonAutomate
        },

        setDeptAutocompleteNonAutomate  (state, deptAutocompleteNonAutomate) {
            state.deptAutocompleteNonAutomate = deptAutocompleteNonAutomate
        },

        setDVMSelectedNonAutomate  (state, dvmSelectedNonAutomate) {
            state.dvmSelectedNonAutomate = dvmSelectedNonAutomate
        },

        setDeptSelectedNonAutomate  (state, deptSelectedNonAutomate) {
            state.deptSelectedNonAutomate = deptSelectedNonAutomate
        },

        setCheckedRowsDetailNonAutomate  (state, checkedRowsDetailNonAutomate) {
            state.checkedRowsDetailNonAutomate = checkedRowsDetailNonAutomate
        },


        





        // for Automate
        setDVMAutocompleteAutomate  (state, dvmAutocompleteAutomate) {
            state.dvmAutocompleteAutomate = dvmAutocompleteAutomate
        },

        setDeptAutocompleteAutomate  (state, deptAutocompleteAutomate) {
            state.deptAutocompleteAutomate = deptAutocompleteAutomate
        },

        setDVMSelectedAutomate  (state, dvmSelectedAutomate) {
            state.dvmSelectedAutomate = dvmSelectedAutomate
        },

        setDeptSelectedAutomate  (state, deptSelectedAutomate) {
            state.deptSelectedAutomate = deptSelectedAutomate
        },

        setCheckedRowsDetailAutomate  (state, checkedRowsDetailAutomate) {
            state.checkedRowsDetailAutomate = checkedRowsDetailAutomate
        },







        setFirstInteract (state, firstInteract) {
            state.firstInteract = firstInteract
        },



        setDVMArr (state, dvmArr) {
            state.dvmArr = dvmArr
        },

        setDeptArr (state, deptArr) {
            state.deptArr = deptArr
        },
   

        setHNSelected (state, HNSelected) {
            state.HNSelected = HNSelected
        },
        
        setMemberSelected(state, MemberSelected) {
            state.MemberSelected = MemberSelected
        },

        setAutomateOrNoneAutomateMode (state, automateOrNoneAutomateMode) {
            state.automateOrNoneAutomateMode = automateOrNoneAutomateMode
        },

        setItemsSelected (state, ItemsSelected) {
            state.ItemsSelected = ItemsSelected
        },




        setOpdResultSearch (state, opdResultSearch) {
            state.opdResultSearch = opdResultSearch
        },



        setopdPathoJobList (state, opdPathoJobList) {
            // update products
            state.opdPathoJobList = opdPathoJobList
        },

        setDataGroupAndDetailAutomate(state, dataGroupAndDetailAutomate) {
            state.dataGroupAndDetailAutomate = dataGroupAndDetailAutomate
        },
        setDataGroupAndDetailNonAutomate(state, dataGroupAndDetailNonAutomate) {
            state.dataGroupAndDetailNonAutomate = dataGroupAndDetailNonAutomate
        },



    },

    actions: {
        // fetchOPDPathoJobList({commit}) {
        //     return new Promise((resolve) => {
        //         // make the call
        //         // call setProducts mutation
        //         api_patho_opd_job_worklist.getOPDPathoJobList(opdPathoJobList => {
        //             commit('setopdPathoJobList', opdPathoJobList)
        //             resolve()
        //         })
        //     })
        // }
        // <!-- api listofdvm <br/>
        // list_of_departmentappoint  <br/> -->

        fetchDVMArr({commit}) {
            return new Promise((resolve) => {
                axios.defaults.headers.common['Authorization'] =  `Bearer ${master_data.state.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/listofdvm`,getConfigAxios())
                    .then((res)=>{
                        commit('setDVMArr', res.data)
                        resolve(res.data)
                    })
            })

        }, 


        fetchDeptArr({commit}) {
            return new Promise((resolve) => {
                axios.defaults.headers.common['Authorization'] =  `Bearer ${master_data.state.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/list_of_departmentappoint`,getConfigAxios())
                    .then((res)=>{
                        commit('setDeptArr', res.data)
                        resolve(res.data)
                    })
            })

        }, 





        fetchDataGroupAndDetailAutomate({commit}) {
            const datTo ={
                "kind" : 1
            }
            return new Promise((resolve) => {
                axios.defaults.headers.common['Authorization'] =  `Bearer ${master_data.state.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/getjsondatagroupanddetail`,datTo,getConfigAxios())
                    .then((res)=>{
                        commit('setDataGroupAndDetailAutomate', res.data)
                        resolve(res.data)
                    })
            })
        },


        fetchDataGroupAndDetailNonAutomate({commit}) {
            const datTo ={
                "kind" : 0
            }
            return new Promise((resolve) => {
                axios.defaults.headers.common['Authorization'] =  `Bearer ${master_data.state.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/getjsondatagroupanddetail`,datTo,getConfigAxios())
                    .then((res)=>{
                        commit('setDataGroupAndDetailNonAutomate', res.data)
                        resolve(res.data)
                    })
            })
        },


        
        

        fetchJobListOfPathoServices({commit,state}) {
            // const datTo ={
            //     "date_start":   moment.tz(  state.datePathoJobStart , myTimeZone).format('YYYY-MM-DD') +'T'+'00:00:00.000Z' , 
            //     "date_end" :    moment.tz(  state.datePathoJobStop , myTimeZone).format('YYYY-MM-DD') +'T'+'00:00:00.000Z'  
            // }
            // console.log(JSON.stringify(datTo))

            const datTo ={
                // "date_start":   moment.tz(  state.datePathoJobStart , myTimeZone).format('YYYY-MM-DD') +'T'+'00:00:00.000Z' , 
                "date_want" :    moment.tz(  state.datePathoJobStop , myTimeZone).format('YYYY-MM-DD') +'T'+'00:00:00.000Z'  
            }


            return new Promise((resolve) => {
                axios.defaults.headers.common['Authorization'] =  `Bearer ${master_data.state.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/loadjoblistofpathoservicesv2`,datTo,getConfigAxios())
                    .then((res)=>{
                        commit('setopdPathoJobList', res.data)
                        resolve(res.data)
                    })
            })
        },



    }
}